import { SlateText } from "@faire/deprecated-retailer-visitor-shared/components/SlateElements/Text/SlateText";
import { ISlateTextElement } from "@faire/web-api--source/indigofair/data/ISlateTextElement";
import { Button, ButtonVariants } from "@faire/web/slate/Button";
import React from "react";

interface IProps {
  variant: ButtonVariants | undefined;
  textElement: ISlateTextElement | undefined;
  linkTo: string | undefined;
  onClick: () => void;
}

export const SlateButton: React.FC<IProps> = ({
  variant,
  textElement,
  onClick,
  linkTo,
}) => {
  if (!textElement?.text) {
    return null;
  }

  return (
    <Button variant={variant} onClick={onClick} linkTo={linkTo}>
      <SlateText textElement={textElement} isUnderlined />
    </Button>
  );
};
